<template>
  <div>
    <div class="col-lg-12">
      <fieldset>
        <legend>
          Damage Details
          <small class="text-muted"
            >- Please click on the sections of the car to indicate damage.
          </small>
        </legend>
      </fieldset>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour severe"></div>
          <div class="damage-label">Severe</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour major"></div>
          <div class="damage-label">Major</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour minor"></div>
          <div class="damage-label">Minor</div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center">
      <left-vehicle
        v-on:updated="updateLeftDamage"
        :front="car.left_front"
        :frontDoor="car.left_front_door"
        :rearDoor="car.left_rear_door"
        :rear="car.left_rear"
        :frontWheel="car.left_front_wheel"
        :rearWheel="car.left_rear_wheel"
      ></left-vehicle>
    </div>
    <div class="row">
      <div class="col-12 main-images">
        <div class="col-lg-4 col-lg-push-4 text-center roof">
          <vehicle-roof
            v-on:updated="updateRoofDamage"
            :rearWindscreen="car.rear_windscreen"
            :roof="car.roof"
            :frontWindscreen="car.front_windscreen"
            :bonnet="car.top_bonnet"
          ></vehicle-roof>
        </div>
        <div class="col-lg-4 col-lg-pull-4 col-md-6 text-center rear">
          <rear-vehicle
            v-on:updated="updateRearDamage"
            :bumper="car.rear_bumper"
            :boot="car.rear_boot"
          ></rear-vehicle>
        </div>
        <div class="col-lg-4 col-md-6 text-center front">
          <front-vehicle
            v-on:updated="updateFrontDamage"
            :bumper="car.front_bumper"
            :bonnet="car.front_bonnet"
          ></front-vehicle>
        </div>
      </div>
    </div>
    <div class="col-12 text-center">
      <right-vehicle
        v-on:updated="updateRightDamage"
        :front="car.right_front"
        :frontDoor="car.right_front_door"
        :rearDoor="car.right_rear_door"
        :rear="car.right_rear"
        :frontWheel="car.right_front_wheel"
        :rearWheel="car.right_rear_wheel"
      ></right-vehicle>
    </div>

    <div class="col-12 margin-t-10">
      <input-block
        v-model="car.description"
        name="description"
        label="Damage Description"
        helper="Add any additional information details about the vehicle damage here"
      ></input-block>
    </div>
  </div>
</template>

<script>
import Rear from './Car/Rear.vue';
import Roof from './Car/Roof.vue';
import Front from './Car/Front.vue';
import Left from './Car/Left.vue';
import Right from './Car/Right.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    car: {
      type: Object,
      required: true
    }
  },

  components: {
    'rear-vehicle': Rear,
    'vehicle-roof': Roof,
    'front-vehicle': Front,
    'left-vehicle': Left,
    'right-vehicle': Right
  },

  data() {
    return {
      indicator: false,
      categories: [],
      data_entered: false
    };
  },

  computed: {
    client() {
      return this.$store.getters['Incident/client'];
    },

    vehicle() {
      return this.$store.getters['Incident/clientVehicle'];
    }
  },

  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      if (Object.keys(this.client).length && Object.keys(this.vehicle).length) {
        this.setDetails(this.$store.getters['Incident/details']);
        this.updateCar(this.vehicle?.damage);
      }
    },

    updateFrontDamage(value) {
      let refined = {
        front_bumper: value.bumper,
        front_bonnet: value.bonnet
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRightDamage(value) {
      let refined = {
        right_front_door: value.frontDoor,
        right_front: value.frontBumper,
        right_rear_door: value.backDoor,
        right_rear: value.rearBumper,
        right_front_wheel: value.frontWheel,
        right_rear_wheel: value.rearWheel
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateLeftDamage(value) {
      let refined = {
        left_front_door: value.frontDoor,
        left_front: value.frontBumper,
        left_rear_door: value.backDoor,
        left_rear: value.rearBumper,
        left_front_wheel: value.frontWheel,
        left_rear_wheel: value.rearWheel
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRoofDamage(value) {
      let refined = {
        rear_windscreen: value.rearWindscreen,
        roof: value.roof,
        front_windscreen: value.frontWindscreen,
        top_bonnet: value.bonnet
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateRearDamage(value) {
      let refined = {
        rear_bumper: value.bumper,
        rear_boot: value.boot
      };

      this.updateCar(refined);
      this.changeHandler();
    },

    updateCar(data) {
      for (let property in data) {
        if (this.car[property]) {
          this.car[property] = data[property];
        }
      }
      this.$emit('update', this.car);
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
    }
  }
};
</script>
